export const commonPropertySetters = {
  x(value) {
    this.x = value;
  },
  y(value) {
    this.y = value;
  },
  opacity(value) {
    this.alpha = value;
  },
  visible(value) {
    this.visible = value;
  },
  angle(value) {
    this.angle = value;
  },
  width(value) {
    this.width = value;
  },
  height(value) {
    this.height = value;
  },
  scale(values) {
    this.setScale(values);
    // if(typeof values==='number')this.scale.set(values);
    // else if(typeof values ==='object'){
    //     this.scale.set(values.x,values.y)
    // }
  },
  origin(values) {
    if (typeof values === 'number') this.anchor.set(values);
    else if (typeof values === 'object') {
      this.anchor.set(values.x, values.y);
    }
  },
  pivot(values) {
    if (typeof values === 'number') this.pivot.set(values);
    else if (typeof values === 'object') {
      this.pivot.set(values.x, values.y);
    }
  },
  roundPixels(v) {
    this.roundPixels = v;
  },
};
